module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_0.565503f6.png";